import { queryOptions, useQuery } from '@tanstack/react-query'
import { InferRequestType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type FindUsersArgs = InferRequestType<typeof apiClient.users.$get>['query']

export const findUsersQueryOptions = (args: FindUsersArgs) =>
  queryOptions({
    queryKey: ['user', args],
    queryFn: () =>
      apiClient.users.$get({ query: args }).then((r) => formatClientResponse(r)),
  })

export const useFindUsers = (
  args: FindUsersArgs,
  options?: Partial<ReturnType<typeof findUsersQueryOptions>>
) =>
  useQuery({
    ...findUsersQueryOptions(args),
    ...options,
  })
